import { GetTop100ItemsApiParameter } from "@galarson/Handlers/Top100Items/Top100ItemsService";
import CustomApplicationState from "@galarson/Store/CustomApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { createContext } from "react";

export function getOrdersDataView(state: any) {
    return state.customData.Top100Item;
}
export const Top100ItemsDataViewContext = createContext<ReturnType<typeof getOrdersDataView>>({
    isLoading: false,
    getTop100ItemsApiParameter : {
        sort: "",
        customerNumber: ""
    },
    top100Items:[]
});

